import React, { ReactNode, CSSProperties } from 'react';
import './Row.css';

interface RowProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const Row = ({ children, className = '', style = {} }: RowProps) => (
  <div className={`row ${className}`} style={style}>
    {children}
  </div>
);

export default Row;
